import dayjs from "dayjs";
import dayjsFormatter from "dayjs/plugin/customParseFormat";
import { FiscalYear } from "../state/company";

dayjs.extend(dayjsFormatter);

export const fiscalPeriodsCount = 5;

/**
 * Computes all fiscal years available for the given date range expressed as [start month-start day, end month-end day].
 *
 * @param start
 * @param end
 */
export const computeFiscalYears = (start: string, end: string): FiscalYear[] => {
	const today = dayjs();
	const currentYear = today.year();

	// ignore hours, minutes and seconds
	const fixedToday = dayjs(`${currentYear}-${today.format("MM-DD")}`, "YYYY-MM-DD");

	let endDate = dayjs(`${currentYear}-${end}`, "YYYY-MM-DD");
	let startDate = dayjs(`${currentYear}-${start}`, "YYYY-MM-DD");

	if (startDate.isAfter(fixedToday)) {
		startDate = startDate.subtract(1, "year");
	}

	if (endDate.isBefore(fixedToday)) {
		endDate = endDate.add(1, "year");
	}

	const years: FiscalYear[] = [];
	for (let id = 0; id < fiscalPeriodsCount; id++) {
		const start = startDate.subtract(id, "year");
		const end = endDate.subtract(id, "year");
		years.push({ id, start, end });
	}

	return years;
};
